/*
 * @Author: 李才人
 * @Date: 2021-07-05 11:07:47
 * @LastEditors: 李才人
 * @LastEditTime: 2021-07-12 11:52:30
 * @FilePath: \m_saas_business_admin\src\utils\userStorage.ts
 * @Description:
 */

// import store from "../store";

import { setCookie, getCookie, get, set, remove, removeCookie } from "@utils/localStorageUtil";
import { ls_userInfo, ls_comtyInfo, ls_isHaveOrgAuth, ls_bId, ls_orgInfo, ls_comtyId, ls_token, ls_proxy_token, ls_token_new, ls_comtyId_new, ls_comtyId_token, ls_comtyInfo_new, ls_userInfo_new } from "@/dataBase/localStorageKeys";

// const orgInfo = hasStorage(ls_orgInfo) ? get(ls_orgInfo) : "";

export function logoutRemove() {
  removeToken();
  removeBId();
  removecomtyId();
  removeUserInfo();
  removeComtyInfo();
  removeOrgInfo();
}
export function logoutRemoveNew() {
  removeTokenNew();
  removecomtyIdNew();
  removeComtyInfoNew();
}
// 获取用户信息
export function getUserInfo() {
  return get(ls_userInfo);
}
// 设置用户信息
export function setUserInfo(userInfo: any) {
  set(ls_userInfo, userInfo);
}
// 移除用户信息
export function removeUserInfo() {
  remove(ls_userInfo);
}

// 获取社区信息
export function getComtyInfo() {
  return get(ls_comtyInfo);
}
// 设置社区信息
export function setComtyInfo(comtyInfo: any) {
  set(ls_comtyInfo, comtyInfo);
}
// 移除社区信息
export function removeComtyInfo() {
  remove(ls_comtyInfo);
}
// 获取机构信息
export function getOrgInfo() {
  return get(ls_orgInfo);
}
// 设置机构信息
export function setOrgInfo(orgInfo: any) {
  set(ls_orgInfo, orgInfo);
}
// 设置是否拥有预约通的权限
export function setIsAuth(isAuth: boolean) {
  set(ls_isHaveOrgAuth, isAuth);
}
// 获取有预约通的权限
export function getIsAuth() {
  return get(ls_isHaveOrgAuth);
}
// 移除机构信息
export function removeOrgInfo() {
  remove(ls_orgInfo);
}
// 获取comtyId
export function getComtyId() {
  return getCookie(ls_comtyId);
}
// 设置comtyId
export function setComtyId(comtyId: any) {
  setCookie(ls_comtyId, comtyId);
}
// 移除comtyId
export function removecomtyId() {
  removeCookie(ls_comtyId);
}
// 设置bId
export function setBId(bId: any) {
  setCookie(ls_bId, bId);
}
// 移除bId
export function removeBId() {
  removeCookie(ls_bId);
}
// 获取token
export function getToken() {
  // console.log("getTOken", getCookie(ls_token), getCookie(ls_token));
  return getCookie(ls_token);
}
// 设置token
export function setToken(token: any) {
  setCookie(ls_token, token);
}

// 获取新健康社区token
export function getTokenNew() {
  return getCookie(ls_token_new);
}
// 设置新健康社区token
export function setTokenNew(token: any) {
  console.log("[login]setTokenNew", token);
  setCookie(ls_token_new, token);
}
// 移除token
export function removeTokenNew() {
  removeCookie(ls_token_new);
}
// 设置代运营token
export function setProxyToken(token: any) {
  setCookie(ls_proxy_token, token);
}
// 获取token
export function getProxyToken() {
  return getCookie(ls_proxy_token);
}
// 移除token
export function removeToken() {
  removeCookie(ls_token);
  remove(ls_token);
  removeCookie(ls_comtyId_token);
}

// & 清除积分开关标记
export const removePointsStatus = () => {
  localStorage.removeItem("clearIntetralStatus");
};

// 获取bId
export function getBId() {
  return getCookie(ls_bId);
}
// 获取新comtyId
export function getComtyIdNew() {
  return getCookie(ls_comtyId_new);
}
// 设置新comtyId
export function setComtyIdNew(comtyId: any) {
  setCookie(ls_comtyId_new, comtyId);
}
// 移除新comtyId
export function removecomtyIdNew() {
  removeCookie(ls_comtyId_new);
}
// 设置新comtyId TOKEN
export function setComtyIdToken(token: any) {
  setCookie(ls_comtyId_token, token);
}
// 获取新comtyId TOKEN
export function getComtyIdToken() {
  return getCookie(ls_comtyId_token);
}
// 移除新comtyId TOKEN
export function removeComtyIdToken() {
  removeCookie(ls_comtyId_token);
}
// 获取社区信息
export function getComtyInfoNew() {
  return get(ls_comtyInfo_new);
}
// 设置社区信息
export function setComtyInfoNew(comtyInfo: any) {
  set(ls_comtyInfo_new, comtyInfo);
}
// 移除社区信息
export function removeComtyInfoNew() {
  remove(ls_comtyInfo_new);
}
// 获取用户信息
export function getUserInfoNew() {
  return get(ls_userInfo_new);
}
// 设置用户信息
export function setUserInfoNew(userInfo: any) {
  set(ls_userInfo_new, userInfo);
}
// 移除用户信息
export function removeUserInfoNew() {
  remove(ls_userInfo_new);
}
// 设置是否为外部页面
export function setExternal(value: Boolean) {
  setCookie("external", value);
}
// 获取是否为外部页面
export function getExternal() {
  return getCookie("external");
}
